import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { isEqual, cloneDeep } from 'lodash';

import { session } from '../../../services/session';
import { linksService } from './links-service';

import Search from '../../ui/search/search';
import MocksButton from '../../misc/mocks-button';
import StoryModal from './story-modal';
import Story from './story';

const mockData = linksService.getMockData();

const SelectStory = ({ selectedStory, setSelectedStory }) => {
  const [didMount, setDidMount] = useState(false);
  const [data, setData] = useState([]);
  const [showMocks, setShowMocks] = useState(false);
  const [query, setQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [newlyCreatedStory, setNewlyCreatedStory] = useState(false);

  const [pages, setPages] = useState({ pages: 1 });
  const [loadMore, setLoadMore] = useState(1);
  const list = useRef(null);

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    if (didMount) {
      list.current.scrollTo(0, 0);
      setPages({ pages: 1 });
    }
  }, [query]);

  useEffect(() => {
    getData();
  }, [pages]);

  useEffect(() => {
    if (showMocks) {
      setData(mockData);
    }
  }, [showMocks]);

  async function getData() {
    const params = {
      page: pages.pages,
      ...(query ? { search_query: query } : {}),
    };

    const res = await linksService.getEdits(session.orgId, params);

    if (pages.pages > 1) {
      setData(data.concat(res.data.data[0].edits));
    } else {
      setData(res.data.data[0].edits);
    }

    setLoadMore(res.data.data[0].page_info.next_page);
  }

  async function handleModalSelect(story) {
    try {
      const res = await linksService.createStory(session.orgId, story);
      const newStory = res.data.data[0].edit;
      const newStories = [newStory].concat(cloneDeep(data));

      setData(newStories);
      setNewlyCreatedStory(newStory);
      setSelectedStory(newStory);
      setShowModal(false);
    } catch {
      alert('Failed to save');
    }
  }

  function handleScroll() {
    const el = list.current;
    if (el.offsetHeight + el.scrollTop >= el.scrollHeight && loadMore) {
      setPages({ pages: pages.pages + 1 });
    }
  }

  const storyItems = data.map((story, index) => (
    <Story
      key={index}
      story={story}
      selectedStory={selectedStory}
      handleClick={() => setSelectedStory(story)}
      newlyCreated={isEqual(story, newlyCreatedStory)}
    />
  ));

  const createStoryModal = showModal ? (
    <StoryModal setShowModal={setShowModal} handleSubmit={handleModalSelect} />
  ) : null;

  const continueButtonContent = selectedStory ? (
    <Link
      to={`/v2/publisher/${session.orgId}/links/create-links/paste-product-urls?edit_id=${selectedStory.edit_id}`}
    >
      Continue to Next Step
    </Link>
  ) : (
    'Continue to Next Step'
  );

  return (
    <div className="select-story">
      <h2>Select a Post</h2>
      <div className="description">
        Pick the post you’ll be adding links to, or create a new post.
      </div>
      <Search debounce={true} onSearch={setQuery} placeholder="Search for a Post" />
      <button className="create-new-story-btn" onClick={() => setShowModal(true)}>
        <span className="plus">+</span>
        <span>Create New Post</span>
      </button>
      <div className="list-title">Most Recent Posts</div>
      <div className="links-stories" ref={list} onScroll={handleScroll}>
        {storyItems}
      </div>
      <button className={`continue-btn ${!selectedStory ? 'disabled' : ''}`}>
        {continueButtonContent}
      </button>
      {createStoryModal}
      <MocksButton setShowMocks={setShowMocks} showMocks={showMocks} />
    </div>
  );
};

export default SelectStory;
